<template>
  <BListItem class="mb-200">
    <template
      v-if="Object.keys(items).length <= 0"
      #header
    >
      <span>{{ title }}</span>
      <span class="ml-200">
        <slot
          name="notification"
        />
      </span>
    </template>
    <template
      v-else
      #header
    >
      <span>{{ title }}</span>
      <span
        v-if="editing"
        class="btn-area ml-200"
      >
        <BBtn
          v-if="valueChanged"
          class="mr-50"
          size="small"
          fab
          flat
          :loading="loading"
          :data-test="`${node}Btn`"
          @click="handleClickItemsCheck"
        >
          <BIcon
            class="check-icon"
            size="small"
          >
            check
          </BIcon>
        </BBtn>
        <BBtn
          size="small"
          fab
          flat
          :disabled="loading"
          @click="handleClickClose"
        >
          <BIcon
            class="close-icon"
            size="small"
          >
            close
          </BIcon>
        </BBtn>
      </span>
    </template>
    <VWait
      class="full-width"
      for="none"
      :visible="$wait.is('getCallTargetWait')"
    >
      <template #waiting>
        <BContentLoader
          :height="24"
          :width="230"
        >
          <rect
            x="0"
            y="8.5"
            rx="6"
            ry="6"
            width="160"
            height="12"
          />
        </BContentLoader>
      </template>
      <BLayout
        v-if="Object.keys(items).length <= 0"
        class="list-content"
        row
      >
        <BEditableContent
          v-model:editing="editing"
          :value="value"
          :placeholder="title"
          hyphen
          :loading="loading"
          :rules="rules"
          :data-test="node"
          :uneditable="!editable"
          @check="handleClickCheck"
        />
        <slot
          v-if="!editing"
          name="help"
        />
      </BLayout>
      <template v-else>
        <template v-if="editing">
          <BLayout
            v-for="(item, key) in items"
            :key="key"
            class="list-content list-loop"
            row
          >
            <BInput
              v-model="newItems[key]"
              class="input-area"
              :placeholder="newItems[key] || $t(`companyInfo.item.${key}`)"
              :rules="rules"
              :disabled="loading"
              :max-length="255"
              :data-test="key"
              type="text"
            />
          </BLayout>
        </template>
        <template v-else>
          <BLayout
            class="list-content"
            row
          >
            <BEditableContent
              v-model:editing="editing"
              :value="value"
              :placeholder="$t('companyInfo.item.companyAddress')"
              hyphen
              :loading="loading"
              :rules="rules"
              :data-test="node"
              @check="handleClickCheck"
            />
            <slot
              name="help"
            />
          </BLayout>
        </template>
      </template>
    </VWait>
  </BListItem>
</template>

<script>
import lodash from 'lodash';

export default {
  props: {
    title: String,
    node: String,
    editingNode: String,
    value: String,
    loading: Boolean,
    rules: {
      type: Array,
      default () {
        return [];
      },
    },
    items: {
      type: Object,
      default () {
        return {};
      },
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  emits: [
    'update:editing-node',
    'save',
    'cancel',
  ],
  data () {
    return {
      editing: false,
      newItems: lodash.cloneDeep(this.items),
    };
  },
  computed: {
    valueChanged () {
      return Object.keys(this.items).some((key) => this.items[key] !== this.newItems[key]);
    },
  },
  watch: {
    editingNode (newVal) {
      if (newVal !== this.node) this.editing = false;
    },
    editing (newVal) {
      if (newVal) {
        this.$emit('update:editing-node', this.node);
        // data()でもやってるけど、そのタイミングではコピーできてないのでこっちでもやる
        this.newItems = lodash.cloneDeep(this.items);
      }
    },
  },
  methods: {
    handleClickCheck (event) {
      this.$emit('save', { [this.node]: event });
    },
    handleClickItemsCheck () {
      this.$emit('save', this.newItems);
      this.editing = false;
    },
    handleClickClose () {
      this.$emit('cancel');
      this.newItems = lodash.cloneDeep(this.items);
      this.editing = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .list-content {
    position: relative;
    width: 100%;
    word-wrap: break-word;
    word-break: break-all;

    &.list-loop {
      margin-bottom: $basespace-100;
    }
  }

  .btn-area {
    vertical-align: middle;
    line-height: 30px;

    .check-icon {
    color: $basecolor-primary;
    }
    .close-icon {
      color: $textcolor-light;
    }
  }
</style>
